import { StandardEvents } from '@shopify/events';

const CONTAINER_SELECTOR = '[id*="ProductInformation-"], [id*="QuickAdd-"], product-card';

/**
 * Shows the warm / cool pearl tone choice only when the selected variant
 * matches the trigger option value (e.g. "Peacock").
 * Hidden inputs are disabled so they are neither required nor sent to the cart.
 */
class PearlToneComponent extends HTMLElement {
  /** @type {HTMLElement | null} */
  #container = null;

  connectedCallback() {
    this.#container = this.closest(CONTAINER_SELECTOR);
    this.#container?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#container?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#container = null;
  }

  /**
   * @param {Event & { promise: Promise<{ detail?: any }> }} event
   */
  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.resource) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;

        const trigger = (this.dataset.triggerValue || '').trim().toLowerCase();
        const options = Array.isArray(detail.resource.options) ? detail.resource.options : [];
        const isVisible = options.some((value) => String(value).trim().toLowerCase() === trigger);

        this.#setVisible(isVisible);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[pearl-tone] Event promise rejected:', error);
      });
  };

  /**
   * @param {boolean} isVisible
   */
  #setVisible(isVisible) {
    this.hidden = !isVisible;

    for (const input of this.querySelectorAll('input')) {
      input.disabled = !isVisible;
      if (!isVisible) input.checked = false;
    }
  }
}

if (!customElements.get('pearl-tone-component')) {
  customElements.define('pearl-tone-component', PearlToneComponent);
}
